import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeRequest } from "../../api/api";

export const getSettlementDues = createAsyncThunk(
  'user/getSettlementDues',
  async (settlementParams) => {
    // Accept either a plain string/keyword or a params object with filters
    let query = "";
    if (settlementParams && typeof settlementParams === "object") {
      const { keyword, doc, shipowner_name, vessel_name, imo_number, casper_id, requested_year } = settlementParams;
      const parts = [];
      if (keyword)        parts.push(`keyword=${encodeURIComponent(keyword)}`);
      if (doc)            parts.push(`doc=${encodeURIComponent(doc)}`);
      if (shipowner_name) parts.push(`shipowner_name=${encodeURIComponent(shipowner_name)}`);
      if (vessel_name)    parts.push(`vessel_name=${encodeURIComponent(vessel_name)}`);
      if (imo_number)     parts.push(`imo_number=${encodeURIComponent(imo_number)}`);
      if (casper_id)      parts.push(`casper_id=${encodeURIComponent(casper_id)}`);
      if (requested_year) parts.push(`requested_year=${encodeURIComponent(requested_year)}`);
      query = parts.join("&");
    } else {
      // Plain string keyword (search box usage)
      query = settlementParams ? `keyword=${settlementParams}` : "";
    }
    const url = `v2/home/get_settlement_dues/${query ? "?" + query : ""}`;
    const request = await makeRequest("get", url);
    const data = request.data.data;
    // data = { rows: [...], graph: { total_eu_ets, total_uka, total_penalty } }
    return { rows: data?.rows || data || [], graph: data?.graph || null };
  }
)


export const getEuaOutstanding = createAsyncThunk(
  'user/getEuaOutstanding',
  async (param) => {

    const request = await makeRequest("post", "v2/home/get_cumulative_eua_info/", param)
    const response = await request.data.data
    return response
  }
)


export const fetchCSVDocument = createAsyncThunk(
  "voyage/generateStatementDocument",
  async (params, date) => {
    const { start_date, end_date } = params
    const request = await makeRequest("get", `v2/home/generate_document/?doc_type=csv&start_date=${start_date}&end_date=${end_date}`)
    const response = await request.data.data
    return response
  }
)


export const fetchCSVDocumentforVessels = createAsyncThunk(
  "voyage/generateStatementDocument",
  async (params, date) => {
    const { start_date, end_date, imo_number } = params
    const request = await makeRequest("get", `v2/home/generate_document/?imo_number=${imo_number}&doc_type=csv&start_date=${start_date}&end_date=${end_date}`)
    const response = await request.data.data
    return response
  }
)

export const getEUPortsEnteringVessels = createAsyncThunk(
  'user/getEUPortsEnteringVessels',
  async(page)=>{
    const request = await makeRequest("get", `v2/home/get_eu_ports_entering_vessels/?requested_page=${page}`)
    const response = await request.data.data;
    return response;
  }
)


const EuaSlice = createSlice({
  name: 'dues',
  initialState: {
    status: 'idle',
    dues: null,
    duesGraph: null,
    euportsenteringvessels: [],
    cummulativeInfo: {
      status: 'idle',
      data: null,
    },
    csvDocument: null,
  },
  reducers: {
    duesCleaner: (state) => {
      state.dues = null;
      state.duesGraph = null;
      state.status = 'loading';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSettlementDues.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getSettlementDues.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (action.payload === null) {
          state.dues = [];
          state.duesGraph = null;
        } else {
          // rows array → used by ExpandableTable (expects array with active_owner, vessel_name etc.)
          state.dues = Array.isArray(action.payload.rows)
            ? action.payload.rows
            : (Array.isArray(action.payload) ? action.payload : []);
          state.duesGraph = action.payload.graph || null;
        }
      })
      .addCase(getSettlementDues.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getEuaOutstanding.pending, (state) => {
        state.cummulativeInfo.status = 'loading';
      })
      .addCase(getEuaOutstanding.fulfilled, (state, action) => {
        state.cummulativeInfo.status = 'succeeded';
        state.cummulativeInfo.data = action.payload;
      })
      .addCase(getEuaOutstanding.rejected, (state) => {
        state.cummulativeInfo.status = 'failed';
      })
      .addCase(fetchCSVDocument.fulfilled, (state, action) => {
        state.csvDocument = action.payload
      })
      .addCase(fetchCSVDocument.rejected, (state, action) => {
        state.csvDocument = null
      })
      .addCase(getEUPortsEnteringVessels.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getEUPortsEnteringVessels.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.euportsenteringvessels = [...state.euportsenteringvessels, ...action.payload];;
      })
      .addCase(getEUPortsEnteringVessels.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { duesCleaner } = EuaSlice.actions;

export default EuaSlice.reducer